import axios from 'axios';
const configHeaders = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

export default {
  deleteProductionCharge({ commit, state }) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${process.env.VUE_APP_API_URL}/api/dealers/production/models/${state.charge.id}/delete-charge`,
        )
        .then(
          res => {
            resolve(res.data);
            commit('updateProductionChargeDelete', res.data.supplier_charge);
          },
          error => {
            reject(error);
          },
        );
    });
  },

  addProductionCharge(
    { commit },
    {
      model_id,
      charge,
      systemIndex,
      modelIndex,
      subIndex,
      is_default_charge,
      charge_type,
      currency,
    },
  ) {
    const body = [
      {
        model_id,
        charge,
        charge_type,
        ...(currency?.id && { charge_currency: currency.id }),
      },
    ];
    
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/production/update-models`, body).then(
        res => {
          resolve(res.data);
          commit('updateProductionCharge', {
            charge,
            systemIndex,
            modelIndex,
            subIndex,
            is_default_charge,
            charge_type,
            currency,
          });
        },
        error => {
          reject(error);
        },
      );
    });
  },

  productionDelete({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      axios.delete(`${process.env.VUE_APP_API_URL}/api/dealers/production/delete-price/${id}`).then(
        res => {
          resolve(res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  productionLoad({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/production/config`).then(
        res => {
          resolve(res.data);

          commit('productionUpdate', res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  warehouseLoad({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/dealers/production/warehouse`).then(
        res => {
          resolve(res.data);
          commit('warehouseUpdate', res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  loadProductionPrices({ commit, getters }, { system, model, id }) {
    return new Promise((resolve, reject) => {
      axios.get(`${process.env.VUE_APP_API_URL}/api/models/${id}/get-production-prices`).then(
        res => {
          commit('updatePricesPopup', {
            system,
            model,
            id,
          });
          
          let { dealer, supplier } = res.data;
          
          if (dealer) {
            dealer.prices.result.forEach(el => {
              el.price_type_0 = null;
              el.price_type_1 = el.result ?? null;
              el.price_type_2 = el.result ?? null;
              el.price_type_3 = el.result ?? null;
            });
          }
          
          commit('updatePrices', { dealer, supplier });
          resolve(res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  warehouseDownloadFile({ commit }, { body }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.VUE_APP_API_URL}/api/dealers/upload-warehouse`, body, configHeaders)
        .then(
          res => {
            resolve(res.data);
          },
          error => {
            reject(error);
          },
        );
    });
  },

  saveProductionPrices({ state, commit }, body) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/dealers/production/models/${state.pricesPopup.id}/update-prices-matrices`,
          body,
          configHeaders,
        )
        .then(
          res => {
            resolve(res.data);
          },
          error => {
            reject(error);
          },
        );
    });
  },

  productionModelDaySet({ commit }, { body }) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/production/update-models`, body).then(
        res => {
          resolve(res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },

  productionMaterialDaySet({ commit }, { system, day }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${process.env.VUE_APP_API_URL}/api/dealers/production/update-material`, {
          system: system,
          days: day,
        })
        .then(
          res => {
            resolve(res.data);
          },
          error => {
            reject(error);
          },
        );
    });
  },

  productionSelectDays(
    { commit, dispatch, state },
    { data, day, systemIndex, modelIndex, materialUpdate },
  ) {
    commit('common/updatePreload', '', { root: true });
    const system = state.production[systemIndex];
    const model = state.production[systemIndex].models[modelIndex];

    new Promise(res => {
      if (materialUpdate) {
        const materialIndex = system.models.findIndex(item => item.id === null);

        if (materialIndex !== -1) {
          dispatch('productionMaterialDaySet', {
            system: system.id,
            day: day,
          })
            .then(() => {
              commit('productionDayMaterialUpdate', {
                index: systemIndex,
                itemIndex: materialIndex,
                day: day,
              });
            })
            .finally(() => {
              res(true);
            });
        } else {
          res(true);
        }
      } else {
        res(true);
      }
    }).finally(() => {
      if (data.length) {
        dispatch('productionModelDaySet', {
          body: data,
        })
          .then(() => {
            commit('updateProductionSelectDays', {
              data: data,
              day: day,
              systemIndex: systemIndex,
              modelIndex: modelIndex,
            });
          })
          .finally(() => {
            commit('common/updatePreload', '', { root: true });
          });
      } else {
        commit('common/updatePreload', '', { root: true });
      }
    });
  },

  warehouseDateSet({ commit }, { type, body }) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API_URL}/api/dealers/update-warehouse/${type}`, body).then(
        res => {
          resolve(res.data);
        },
        error => {
          reject(error);
        },
      );
    });
  },
};
